import { lazy, Suspense, useContext } from "react";

import { appDataContext } from "@/context";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import Button from "@/components/_common/Button";

const ModalCenterOverlay = lazy(() =>
  import("@/components/popups/ModalCenterOverlay")
);

const RegisterNewsletterPopup = ({ handleClose, setCookie5Days }) => {
  const navigate = useNavigate();
  const dataContext = useContext(appDataContext);
  const text = dataContext?.lang;
  return (
    <Suspense>
      <ModalCenterOverlay
        SetItemVisibility={() => handleClose()}
        $forceClickClose={true}
        $noFullScreenMobile={true}
      >
        <ModalContent>
          <ModalTitle>{text?.summome.title}</ModalTitle>
          <p>{text?.summome.intro}</p>
            <Button
              $fullwidth
              color="green"
              $small
              onClick={(e) => {
                navigate("/belgique/newsletter");
                setCookie5Days();
                handleClose(e);
              }}
            >
              {text?.summome.button}
            </Button>
        </ModalContent>
      </ModalCenterOverlay>
    </Suspense>
  );
};

export default RegisterNewsletterPopup;

const ModalContent = styled.div.attrs({
  className: "ModalContent",
})`
  justify-content: center;
  align-items: center;
  max-width: 90vw;
  max-height: 90vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px;
  border-radius: 8px;
  margin: auto;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media screen and (min-width: 768px) {
    padding: 40px;
    max-width: 60vw;
    max-height: 60vh;
  }
`;

const ModalTitle = styled.h1`
  font-size: 2.2rem;
  text-align: center;
  font-weight: 400;
  @media screen and (min-width: 768px) {
    font-size: 2.4rem;
  }
`;
